<template>
  <argon-badge v-if="type == 'obbligatorio'" size="sm" color="primary">{{$t('Obbligatorio')}}</argon-badge>
  <argon-badge v-else-if="type == 'aggiuntivo'" size="sm" color="primary">{{$t('Aggiuntivo')}}</argon-badge>
  <argon-badge v-else-if="type == 'incluso'" size="sm" color="primary">{{$t('Incluso')}}</argon-badge>
  <argon-badge v-else size="sm" color="danger">{{$t('Sconosciuto')}}</argon-badge>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";

export default {
  name: "ServizioTypeBadge",
  components: {ArgonBadge},
  props: {
    type: {
      type: String,
      default: ""
    }
  }
};
</script>
